export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_04_04_loop.e1ce00e7.mp4";